const Title = ({ text1, text2, noMargin = false }) => {
    return (
        <div className='inline-flex gap-2 items-center mb-3'>
            <p className='text-[#FA6300]'>{text1}{noMargin ? '' : ' '}<span className='text-[#462A71] font-medium'>{text2}</span></p>
            <p className="hidden sm:block w-8 sm:w-12 h-[1px] sm:h-[2px] bg-[#462A71]"></p>
        </div>
    )
}

export default Title
